@if (isLoading$ | async) {
  <section class="loading-overlay" aria-busy="true" aria-live="polite">
    <div class="loading-overlay__backdrop"></div>
    <div class="loading-overlay__card" role="status" aria-label="Loading">
      <i class="fa-solid fa-circle-notch loading-overlay__icon" aria-hidden="true"></i>
    </div>
  </section>
}
